import { render } from "./jhi-navbar.vue?vue&type=template&id=2bdb39d1&scoped=true&ts=true"
import script from "./jhi-navbar.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-navbar.component.ts?vue&type=script&lang=ts&external"

import "./jhi-navbar.vue?vue&type=style&index=0&id=2bdb39d1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdb39d1"]])

export default __exports__